import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import currencyFormatter from 'currency-formatter';
import { analyzeClickEvent } from '../../../../shared/Actions/AnalyticsActions';
import './AccordionContent.css';
import { getSessionValues } from 'shared/Helpers/Utils';
import envConfig from 'env/EnvConfig';

const autoStyle41 = {display:"flex",justifyContent: "end"}
const autoStyle40 = {fontSize: '16px'};
const autoStyle29 = {fontSize: '16px'};
const autoStyle28 = {fontSize: '16px', marginRight: '20px'};
const autoStyle27 = {display:"flex",justifyContent:"left"};
const autoStyle26 = { fontSize: '16px', marginRight: '20px' };
const autoStyle25 = { display: 'flex', justifyContent: "space-between" };
const autoStyle24 = {fontSize: '16px'};
const autoStyle23 = {fontSize: '16px'};
const autoStyle22 = {fontSize: '16px'};
const autoStyle21 = {display:"flex",justifyContent:"space-between"};
const autoStyle20 = {float:"right", color: "#000", fontSize: "16px"};
const autoStyle19 = { float: "right", color: "#21847E", fontSize: "12px", textDecoration: "underline" };
const autoStyle18 = { width: '230px' };
const autoStyle17 = { display: "flex", alignItems: "center", justifyContent: "space-between" };
const autoStyle16 = { cursor: 'pointer', color: 'rgb(0, 74, 152)', fontSize: '12px', fontWeight: 'bold' };
const autoStyle15 = { cursor: 'pointer', color: 'rgb(0, 74, 152)', fontSize: '12px', fontWeight: 'bold' };
const autoStyle14 = { marginBottom: '3%' };


const AcHolderAcrdCont = styled.div`
    display: flex;
    justify-content: space-between;
    flex-flow: row;
    flex-direction: column;
`;

const assignObj = obj => obj;

const CreateLink = props => {
    const {
        isNewBrokerageTab = false,
        isEducationTab = false,
        accountStatus = '',
        linkId,
        name,
        id,
        isAscensus = false,
        isBrokerage = false,
        history,
        accountType,
        handleMSRAscensusClick,
        handleAscensusClick,
        getDashBoardAccordianLinks,
        getGeneratedSAMLAssertion
    } = props;
    const dispatch = useDispatch();
    function handleAnalytics() {
        const screenName = localStorage.getItem('screenName');
        let linkName = accountType;
        if (accountType === 'R') {
            linkName = '529 Regular';
        } else if (accountType === 'U') {
            linkName = '529 UGMA/UTMA';
        }
        dispatch(
            analyzeClickEvent({
                link: `Dashboard_${screenName}_My Portfolio_${linkName} Account`,
            }),
        );
    }

    function onLinkCLick(e ,fun) {
        e.preventDefault();
        if(isBrokerage){
            // make api call here 
            fun({
                "landingPage": "DASHBOARD",
                "acctId": id
            })
        }else{

            handleAnalytics();
            fun({
                returnURL: history.location.pathname,
                accountNumber: id,
                accountType,
            });
        }

        // handleMSRAscensusClick();
    }

    const netXUrl = `${envConfig.NETX360PLUS_SSO}${getSessionValues().vcmid}`
    const isBrokerageORisAscensus = isAscensus ? true : isBrokerage ? true : false
    return isBrokerageORisAscensus !== true ? (
        <Link
            tabIndex="0"
            data-test="transactionLink"
            id={linkId}
            style={assignObj({ color: '#004A98', fontSize: '16px', lineHeight: '30px', fontWeight: 600 })}
            to={assignObj({
                pathname: '/accountholder/transactions',
                name,
                masterId: id,
                accountType:accountType,
                state: {
                    accountDetails:props.accountDetails,
                    name:props.name,
                    masterId: props.accountID,
                    accountType: props.accountType,
                    accountOwnerDesc: props.accountOwnerDesc,
                    ownerType: props.ownerType,
                    taxId: props.taxId,
                    holdingGroup:props.holdingGroup
               },
            })}
            onClick={handleAnalytics}
            className="portfolioLinks"
        >
            {name}
        </Link>
    ) : (
        <a
            href={isBrokerage ? `${netXUrl}` : "about:blank"}
            tabIndex="0"
            data-test={isBrokerage? "brokerageLink":"ascensusLink"}
            // onKeyDown={isBrokerage? null : assignObj(e => onLinkCLick(e, handleAscensusClick))} // For eslint fix
            onClick={isBrokerage? null : assignObj(e => onLinkCLick(e, handleMSRAscensusClick))}
            role="link"
            id={linkId}
                style={(isNewBrokerageTab || isEducationTab) && accountStatus == 'C' ?
                    assignObj({
                        color: 'black',
                        fontSize: '16px',
                        lineHeight: '30px',
                        fontWeight: 600,
                        cursor: 'pointer',
                        pointerEvents: "none",
                    }) : assignObj({
                color: '#004A98',
                fontSize: '16px',
                lineHeight: '30px',
                fontWeight: 600,
                cursor: 'pointer',
            })}
            target="_blank"
            rel="noopener noreferrer"
            className="portfolioLinks"
            onContextMenu={assignObj(e => e.preventDefault())}
        >
            {name}
        </a>
    );
};

const AccordionContent = props => {
    const { investement, isNewBrokerageTab = false, placeATradeonSingleSignOnClick, getDashBoardAccordianLinks, dashBoardLinkData, history, onClickPopupRedirecton, getGeneratedSAMLAssertion, handleMSRAscensusClick, accountDetailsData, isNewDashboardFeatureEnabled = false,
    isEducationTab = false, isFundsTab = false, isMarketTab = false,isWealthTab = false, holdingGroup,PlaceTradeHider,accountActivityHider } = props;
    const holdingGroupDetails =
        investement &&
        investement.reduce((acc, curr) => {
            acc.push({ id: curr.accountID, name: curr.accountName, amount: curr.balance, ...curr });
            return acc;
        }, []);

    const getAllowTransactionDetails = (accountID,transType,infoData) =>
    {
        const {getPostionData} = props;
        getPostionData(accountID,transType,infoData);
    }

    const autoStyle30 = { display: "flex", justifyContent: holdingGroup !== "Closed Accounts" ? "left" :"space-between"};

    return (
        <AcHolderAcrdCont>
            {isEducationTab && holdingGroup == "Closed Accounts" &&
                <div role="row" style={autoStyle14}>
                    <span style={autoStyle15}
                        onClick={props.handleEducationApplicationClosedPopUp}
                    >Why am I seeing my closed accounts?</span>
                </div>
            }
            {
                isNewBrokerageTab && isMarketTab && holdingGroup == "Closed Accounts" ?
                    <div role="row">
                        <span style={autoStyle16}
                            className='brokerage-account-closed' onClick={props.handleApplicationClosedPopUp}>Why am I seeing my closed accounts?</span><br /><br />
                    </div> : null
            }
            {holdingGroupDetails &&
                holdingGroupDetails.map(item => {
                    const linkId = `${item.id}LinktoTransaction`;
                    // const stringId=item.id.toString()
                    return (
                        // isNewDashboardFeatureEnabled ?
                         <>
                        <div className="moblistbox"
                            key={item.id}
                            // className="w-100 portfolioAccordionContent justify-content-between d-flex pr-0 pr-md-2 py-2"
                            role="row"
                        >      
                            <Row className='mb-3'>
                                    <Col xl={(holdingGroup !== "Closed Accounts") ?8:6} md={(holdingGroup !== "Closed Accounts") ?8:6} sm={12} style={autoStyle17} className='pr-4'>
                                    
                                        <span role="cell" style={autoStyle18}>
                                        {isWealthTab ? (
                                            <span style={{ color: '#004A98', fontSize: '16px', lineHeight: '30px', fontWeight: 600, wordBreak:'break-all' }}>
                                                {item.name}
                                            </span>
                                        ) : (
                                        <CreateLink
                                            handleAscensusClick={handleMSRAscensusClick}
                                            onClickPopupRedirecton={onClickPopupRedirecton}
                                            accountDetails={accountDetailsData}
                                            linkId={linkId}
                                            name={item.name}
                                            isBrokerage={item.isBrokerage}
                                            isAscensus={item.isAscensus}
                                            getDashBoardAccordianLinks={getDashBoardAccordianLinks}
                                            getGeneratedSAMLAssertion={getGeneratedSAMLAssertion}
                                            dashBoardLinkData={dashBoardLinkData}
                                                isNewBrokerageTab={isNewBrokerageTab}
                                                isEducationTab={isEducationTab}
                                            history={history}
                                            holdingGroup={holdingGroup}
                                            {...item}
                                        />
                                        )}
                                            {isMarketTab && item?.pendingTransferFlag == true ? <span role="cell" style={autoStyle19}>
                                                Transfer Pending
                                            </span> : null}
                                    </span>
                                    
                                   

                                  
                                        {holdingGroup !== "Closed Accounts" &&
                                    <span role="cell" style={autoStyle20}>
                                        {currencyFormatter.format(item.amount, { locale: 'en-US' })}
                                            </span>}
                                    
                                   
                                
                                </Col>
                               
                                { isFundsTab && 
                                    <Col xl={3} md={3} sm={12}  className="ml-2 align-items-center">
                                        <div style={autoStyle21}>
                                        <p className="fundTextPara" style={autoStyle22} onClick={()=>getAllowTransactionDetails(item.accountID,"Buy",item)}>Buy</p>
                                        <p className="fundTextPara" style={autoStyle23} onClick={()=>getAllowTransactionDetails(item.accountID,"Sell",item)}>Sell</p>
                                        <p className="fundTextPara" style={autoStyle24} onClick={()=>getAllowTransactionDetails(item.accountID,"Exchange",item)}>Exchange</p>
                                        </div>
                                    </Col>
                                }

                                    {isNewBrokerageTab && item?.accountStatus == 'C' ?

                                        (<Col xl={6} md={6} sm={12}>
                                            <div style={autoStyle25}>
                                                <a href={`${envConfig.NETX360PLUS_SSO}${getSessionValues().vcmid}`} target="_blank" rel="noopener noreferrer" style={autoStyle26} >Access Your Documents</a>
                                            </div>
                                        </Col>)

                                        : isMarketTab && 
                                    <Col xl={3} md={3} sm={12}  className="ml-2 pr-0">
                                        <div style={autoStyle27}>
                                       {PlaceTradeHider=="PlaceTradeHider"? "" :<a href={`${envConfig.NETX360PLUS_SSO}${getSessionValues().vcmid}`} target="_blank" rel="noopener noreferrer" style={autoStyle28} >Place a Trade</a>}

                                        <Link 
                                        id="manageMarketTransaction"
                                        to={assignObj({
                                            pathname: '/manageMarketTransaction',
                                            state: {
                                                 accountDetails:accountDetailsData,
                                                 name:item?.name,
                                                 masterId: item?.accountID,
                                                 accountType: item?.accountType,
                                                 accountOwnerDesc: item?.accountOwnerDesc,
                                                 ownerType: item?.ownerType,
                                                 taxId: item?.taxId,
                                                 holdingGroup:holdingGroup,
                                                 PlaceTradeHider:PlaceTradeHider,
                                                 accountActivityHider:accountActivityHider
                                            },
                                        })}

                                         style={autoStyle29} >Manage</Link>
                                        </div>
                                    </Col>
                                }

                                { isEducationTab && 
                                        <Col xl={(holdingGroup !== "Closed Accounts") ? 3 : 6} md={(holdingGroup !== "Closed Accounts") ? 3 : 6} sm={12} className={holdingGroup !== "Closed Accounts" ?"ml-2":""}>
                                            <div style={autoStyle30}>
                                            <CreateLink
                                                handleAscensusClick={handleMSRAscensusClick}
                                                onClickPopupRedirecton={onClickPopupRedirecton}
                                                accountDetails={accountDetailsData}
                                                linkId={linkId}
                                                isBrokerage={item.isBrokerage}
                                                isAscensus={item.isAscensus}
                                                getDashBoardAccordianLinks={getDashBoardAccordianLinks}
                                                getGeneratedSAMLAssertion={getGeneratedSAMLAssertion}
                                                dashBoardLinkData={dashBoardLinkData}
                                                history={history}
                                                {...item}
                                                removeBold={true}
                                                name={holdingGroup !== "Closed Accounts" ? "Manage" : "Access your Documents"}

                                            />
                                        </div>
                                    </Col>
                                }
                                 {isWealthTab &&
                                    <Col xl={4} md={4} sm={12}>
                                        <div style={autoStyle41}>
                                        <Link 
                                        id="manageWealthTransaction"
                                        to={assignObj({
                                            pathname: '/manageWealthTransaction',
                                            state: {
                                                 accountDetails:accountDetailsData,
                                                 name:item?.name,
                                                 masterId: item?.accountID,
                                                 accountType: item?.accountType,
                                                 accountOwnerDesc: item?.accountOwnerDesc,
                                                 ownerType: item?.ownerType,
                                                 taxId: item?.taxId,
                                                 holdingGroup:holdingGroup
                                            },
                                        })}
                                         style={autoStyle40} >Manage</Link>
                                        </div>
                                    </Col> 
                                }
                            </Row>

                        </div>
                        
                    </> 
                    // : <>
                    // <div
                    //     key={item.id}
                    //     //  role="row"
                    // >
                    //     <Row
                    //         style={assignObj({
                    //             paddingTop: 24,
                    //             // paddingLeft: 26,
                    //             textAlign: 'right',
                    //             margin: 0,
                    //             position: 'relative',
                    //             display: 'flex',
                    //             alignItems: 'flex-end',
                    //         })}
                    //         className="w-100 portfolioAccordionContent"
                    //     >
                    //         <Col
                    //             // role="cell"
                    //             className="text-left accordPortfolioAlign"
                    //             xs={7}
                    //         >
                    //             <CreateLink
                    //                 getGeneratedSAMLAssertion={getGeneratedSAMLAssertion}
                    //                 accountDetails={accountDetailsData}
                    //                 linkId={linkId}
                    //                 name={item.name}
                    //                 isAscensus={item.isAscensus}
                    //                 getDashBoardAccordianLinks={getDashBoardAccordianLinks}
                    //                 dashBoardLinkData={dashBoardLinkData}
                    //                 history={history}
                    //                 {...item}
                    //                 handleMSRAscensusClick={handleMSRAscensusClick}
                    //             />
                    //         </Col>
                    //         <Col
                    //             // role="cell"
                    //             className="w-100 p-0 pl-1 pr-1 portfolioAmount"
                    //             style={assignObj({
                    //                 color: '#49494A',
                    //                 fontSize: '16px',
                    //                 lineHeight: '30px',
                    //                 justifyContent: 'flex-end',
                    //                 display: 'flex',
                    //                 width: 'auto',
                    //                 right: '0',
                    //                 // position: 'absolute',
                    //                 minWidth: 107,
                    //             })}
                               
                    //         >
                    //                     {holdingGroup !== "Closed Accounts" && currencyFormatter.format(item.amount, { locale: 'en-US' })}
                    //         </Col>
                    //     </Row>
                    // </div>
                    //  </>
                    );
                })}
        </AcHolderAcrdCont>
    );
};

AccordionContent.propTypes = {
    investement: PropTypes.instanceOf(Object),
    getDashBoardAccordianLinks: PropTypes.func,
    dashBoardLinkData: PropTypes.instanceOf(Object),
    history: PropTypes.instanceOf(Object),
    handleMSRAscensusClick: PropTypes.func,
    getPostionData : PropTypes.func,
};

AccordionContent.defaultProps = {
    investement: {},
    getDashBoardAccordianLinks: () => {},
    dashBoardLinkData: {},
    history: {},
    handleMSRAscensusClick: () => {},
    getPostionData : () => {},
};

CreateLink.propTypes = {
    linkId: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    accountType: PropTypes.string,
    isAscensus: PropTypes.bool,
    getDashBoardAccordianLinks: PropTypes.func,
    history: PropTypes.instanceOf(Object),
    handleMSRAscensusClick: PropTypes.func,
    getPostionData: PropTypes.func,
};

CreateLink.defaultProps = {
    linkId: '',
    name: '',
    id: '',
    accountType: '',
    isAscensus: false,
    getDashBoardAccordianLinks: () => {},
    history: {},
    handleMSRAscensusClick: () => {},
    getPostionData : () => {},
};

export default AccordionContent;
